<!-- Left side column. contains the logo and sidebar -->
<aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- search form -->
      <form method="get" class="sidebar-form">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." />
          <span class="input-group-btn">
            <button type='submit' name='search' id='search-btn' class="btn btn-flat">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </form>
      <!-- /.search form -->
      <!-- sidebar menu: : style can be found in sidebar.less -->
      <ul class="sidebar-menu">
        <li class="header">MAIN NAVIGATION</li>
        <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a routerLink="/">
            <i class="fa fa-dashboard"></i>
            <span>Dashboard</span>
          </a>
        </li>
        <li routerLinkActive="active">
          <a routerLink="/qrcode">
            <i class="fa fa-qrcode" aria-hidden="true"></i>
            <span>QR Code</span>
          </a>
        </li>
        <li *ngIf="isAdmin" routerLinkActive="active">
          <a routerLink="/users">
            <i class="fa fa-users" aria-hidden="true"></i>
            <span>Users</span>
          </a>
        </li>
        <li *ngIf="isAdmin" routerLinkActive="active">
          <a routerLink="/device">
            <i class="fa fa-tablet" aria-hidden="true"></i>
            <span>Device</span>
          </a>
        </li>
        <li *ngIf="isAdmin" routerLinkActive="active">
          <a routerLink="/board">
            <i class="fa fa-square" aria-hidden="true"></i>
            <span>Board</span>
          </a>
        </li>
        <li *ngIf="isAdmin" routerLinkActive="active">
          <a routerLink="/device-board">
            <i class="fa fa-briefcase" aria-hidden="true"></i>
            <span>Device Board</span>
          </a>
        </li>
        <li *ngIf="isAdmin" routerLinkActive="active">
          <a routerLink="/history">
            <i class="fa fa-history" aria-hidden="true"></i>
            <span>History</span>
          </a>
        </li>
        <li *ngIf="isAdmin" routerLinkActive="active">
          <a routerLink="/app-information">
            <i class="fa fa-history" aria-hidden="true"></i>
            <span>App Info</span>
          </a>
        </li>
        <li routerLinkActive="active">
          <a routerLink="/layout-print">
            <i class="fa fa-print" aria-hidden="true"></i>
            <span>Layout Print</span>
          </a>
        </li>
      </ul>
    </section>
    <!-- /.sidebar -->
  </aside>


// WEBPACK FOOTER //
// /build/client-cms/src/app/layout/side-bar/side-bar.component.html